export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4627.7e1a8007.jpg";